export function mapBirthday(bY, bM, bD) {
  if (!bY && !bM && !bD) return '0000-00-00';
  return `${bY}-${bM.length < 2 ? `0${bM}` : bM}-${
    bD.length < 2 ? `0${bD}` : bD
  }`;
}
